// import React from "react";

// const ApLedgerReport = (props) => {
//   const { data, seg, totalMTF } = props;

//   const tableData =
//     seg === "dpc"
//       ? data?.apLadgerBalanceDetails
//       : seg === "prop"
//       ? data?.IntrestProp
//       : data?.IntrestMtf;

//     const tableDataFirst =
//     seg === "dpc"
//       ? data?.totalcount
//       : seg === "prop"
//       ? data?.IntrestProp
//       : data?.IntrestMtf;
// console.log('tableDataFirst',tableDataFirst)
//   const tableStyle = seg === "prop" || seg === "dpc" ? { width: "300%" } : {};

  

//     return (
//     <>
//       {seg === "dpc" && tableDataFirst && (
//         <div className="ap-ledger-report-wrapper">
    
//          {/* Table 1 */}
// <table className="ap-ledger-report table last-column">
//   <tbody>
//     {seg === "dpc" && tableDataFirst && (
//       <tr className="inner-row">
//         {/* LEFT COLUMN */}
//         <td className="left-column">
//           <div className="cell-pair">
//             <span className="title-cell">AP Name</span>
//             <span className="value-cell">{tableDataFirst?.apCode || "-"}</span>
//           </div>
//           <div className="cell-pair">
//             <span className="title-cell">AP Code</span>
//             <span className="value-cell">{tableDataFirst?.apName || "-"}</span>
//           </div>
//         </td>

//         {/* RIGHT COLUMN */}
//         <td className="right-column">
//           <div className="cell-pair">
//             <span className="title-cell">Report Start Date</span>
//             <span className="value-cell">{tableDataFirst?.startDate || "-"}</span>
//           </div>
//           <div className="cell-pair">
//             <span className="title-cell">Report End Date</span>
//             <span className="value-cell">{tableDataFirst?.endDate || "-"}</span>
//           </div>
//         </td>
//       </tr>
//     )}
//   </tbody>
// </table>  


//           {/* Table 2 */}
//           <table className="ap-ledger-report table last-column">
//             <tbody>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From Brokerage</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeFromBrok || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From MTF</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeMtf || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From Mutual Funds</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeFromMutualFund || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From TPP</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeFromTpp || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Amount Paid</td>
//                 <td className="value-cell">{tableDataFirst?.totalAmountPaid || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Amount held so far for RMS Debit</td>
//                 <td className="value-cell">{tableDataFirst?.totalAmountRMSdbt || "-"}</td>
//               </tr>
//             </tbody>
//           </table> 

//           {/* Table 3 */}
//           <table className="ap-ledger-report table last-column">
//             <thead>
//               <tr>
//                 <th>AP NAME</th>
//                 <th>AP CODE</th>
//                 <th className="text-center">DEBIT</th>
//                 <th className="text-center">CREDIT</th>
//                 <th className="text-center">BALANCE</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableData?.map((item, key) => (
//                 <tr key={key} className="inner-row">
//                   <td>{item?.postingDate || "-"}</td>
//                   <td>{item?.text || "-"}</td>
//                   <td>{item?.debit || 0}</td>
//                   <td>{item?.credit || 0}</td>
//                   <td>{item?.balance || 0}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//         </div>
//       )}
//     </>
//   );

//   // return (
//   //   <>
//   //     {tableData?.length > 0 && (
//   //       <div className="table-responsive scroll-table report-table-wrapper ap-ledger-report">
          
//   //         {/* Table 1 */}
//   //         <table className="table last-column">
//   //           <tbody className="scrollablefirst">
//   //             {seg === "dpc" && tableDataFirst && (
//   //               <tr>
//   //                 {/* LEFT SIDE */}
//   //                 <td className="left-side">
//   //                   <table>
//   //                     <tbody>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">AP Name</td>
//   //                         <td className="value-cell">{tableDataFirst?.apCode || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">AP Code</td>
//   //                         <td className="value-cell">{tableDataFirst?.apName || "-"}</td>
//   //                       </tr>
//   //                     </tbody>
//   //                   </table>
//   //                 </td>

//   //                 {/* RIGHT SIDE */}
//   //                 <td className="right-side">
//   //                   <table>
//   //                     <tbody>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Report Start Date</td>
//   //                         <td className="value-cell">{tableDataFirst?.startDate || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Report End Date</td>
//   //                         <td className="value-cell">{tableDataFirst?.endDate || "-"}</td>
//   //                       </tr>
//   //                     </tbody>
//   //                   </table>
//   //                 </td>
//   //               </tr>
//   //             )}
//   //           </tbody>
//   //         </table>

//   //         {/* Table 2 */}
//   //         <table className="table last-column">
//   //           <tbody className="scrollablesecond">
//   //             {seg === "dpc" && tableDataFirst && (
//   //               <tr>
//   //                 <td className="left-side">
//   //                   <table>
//   //                     <tbody>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Total Income From Brokerage</td>
//   //                         <td className="value-cell">{tableDataFirst?.totalIncomeFromBrok || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Total Income From MTF</td>
//   //                         <td className="value-cell">{tableDataFirst?.totalIncomeMtf || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Total Income From Mutual Funds</td>
//   //                         <td className="value-cell">{tableDataFirst?.totalIncomeFromMutualFund || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Total Income From TPP</td>
//   //                         <td className="value-cell">{tableDataFirst?.totalIncomeFromTpp || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Total Amount Paid</td>
//   //                         <td className="value-cell">{tableDataFirst?.totalAmountPaid || "-"}</td>
//   //                       </tr>
//   //                       <tr className="inner-row">
//   //                         <td className="title-cell">Total Amount held so far for RMS Debit</td>
//   //                         <td className="value-cell">{tableDataFirst?.totalAmountRMSdbt || "-"}</td>
//   //                       </tr>
//   //                     </tbody>
//   //                   </table>
//   //                 </td>
//   //               </tr>
//   //             )}
//   //           </tbody>
//   //         </table>

//   //         {/* Table 3 */}
//   //         <table className="table last-column">
//   //           <thead>
//   //             {seg === "dpc" && (
//   //               <tr>
//   //                 <th>AP NAME</th>
//   //                 <th>AP CODE</th>
//   //                 <th className="text-center">DEBIT</th>
//   //                 <th className="text-center">CREDIT</th>
//   //                 <th className="text-center">BALANCE</th>
//   //               </tr>
//   //             )}
//   //           </thead>
//   //           <tbody className="scrollable">
//   //             {tableData?.map((item, key) =>
//   //               seg === "dpc" ? (
//   //                 <tr key={key} className="inner-row">
//   //                   <td>{item?.postingDate || "-"}</td>
//   //                   <td>{item?.text || "-"}</td>
//   //                   <td>{item?.debit || 0}</td>
//   //                   <td>{item?.credit || 0}</td>
//   //                   <td>{item?.balance || 0}</td>
//   //                 </tr>
//   //               ) : null
//   //             )}
//   //           </tbody>
//   //         </table>
//   //       </div>
//   //     )}
//   //   </>
//   // );
  

// //   return (
// //     <>
// //       {tableData?.length > 0 && (
// //         <div className="table-responsive scroll-table report-table-wrapper ">
// //           {/* Table 1 */}
// //          <table
// //   className="table last-column"
// //   style={{
// //     width: "100%",
// //     border: "1px solid #ccc",
// //     borderCollapse: "collapse",
// //   }}
// // >
// //   <tbody
// //     style={{
// //       borderTop: "0",
// //       display: "block",
// //       overflowY: "auto",
// //       overflowX: "hidden",
// //       maxHeight: "300px",
// //       height: "auto !important"
// //     }}
// //   >
// //     {seg === "dpc" && tableDataFirst && (
// //       <tr>
// //         {/* LEFT SIDE */}
// //         <td
// //           style={{
// //             verticalAlign: "top",
// //             width: "50%",
// //             borderRight: "2px solid #ccc", // vertical divider only
// //             padding: "10px",
// //           }}
// //         >
// //           <table
// //             style={{
// //               width: "100%",
// //               borderCollapse: "collapse",
// //             }}
// //           >
// //             <tbody style={{height: "auto !important"}}>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>AP Name</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.apCode || "-"}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>AP Code</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.apName || "-"}
// //                 </td>
// //               </tr>
// //             </tbody>
// //           </table>
// //         </td>

// //         {/* RIGHT SIDE */}
// //         <td
// //           style={{
// //             verticalAlign: "top",
// //             width: "50%",
// //             padding: "10px",
// //           }}
// //         >
// //           <table
// //             style={{
// //               width: "100%",
// //               borderCollapse: "collapse",
// //             }}
// //           >
// //             <tbody style={{height: "auto !important"}}>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Report Start Date</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.startDate || 0}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Report End Date</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.endDate || 0}
// //                 </td>
// //               </tr>
// //             </tbody>
// //           </table>
// //         </td>
// //       </tr>
// //     )}
// //   </tbody>
// // </table>

// //           <br></br>
// //           {/* Table 2 */}

// //            <table
// //   className="table last-column"
// //   style={{
// //     width: "100%",
// //     border: "1px solid #ccc",
// //     borderCollapse: "collapse",
    
// //   }}
// // >
// //   <tbody
// //     style={{
// //       borderTop: "0",
// //       display: "block",
// //       overflowY: "auto",
// //       overflowX: "hidden",
// //       maxHeight: "300px",
// //       height: "auto !important"
// //     }}
// //   >
// //     {seg === "dpc" && tableDataFirst && (
// //       <tr>
// //         {/* LEFT SIDE */}
// //         <td
// //           style={{
// //             verticalAlign: "top",
// //             width: "50%",
// //             borderRight: "2px solid #ccc", // vertical divider only
// //             padding: "10px",
// //           }}
// //         >
// //           <table
// //             style={{
// //               width: "100%",
// //               borderCollapse: "collapse",
// //             }}
// //           >
// //             <tbody  style={{height: "auto !important"}}>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Total Incode From Brokerage</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.totalIncomeFromBrok || "-"}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Total Incode From MTF</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.totalIncomeMtf || "-"}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Total Incode From Mutual Funds</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.totalIncomeFromMutualFund || "-"}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Total Incode From TPP</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.totalIncomeFromTpp || "-"}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Total Amount Paid</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.totalAmountPaid || "-"}
// //                 </td>
// //               </tr>
// //               <tr style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
// //                 <td style={{ padding: "6px" }}>
// //                   <strong>Total Amount held so far for RMS Debit</strong>
// //                 </td>
// //                 <td style={{ padding: "6px" }}>
// //                   {tableDataFirst?.totalAmountRMSdbt || "-"}
// //                 </td>
// //               </tr>
// //             </tbody>
// //           </table>
// //         </td>
// //       </tr>
// //     )}
// //   </tbody>
// // </table>
// // <br></br>
// //  {/* Table 3 */}
// //           {/* Datta added 10-10-2025 */}
// //           <table className="table last-column">
// //             <thead style={{ backgroundColor: "#eae0e03d" }}>
// //               {seg === "dpc" && (
// //                 <tr>
// //                   <th scope="col" className="">
// //                     AP NAME
// //                   </th>
// //                   <th scope="col" className="">
// //                     AP CODE
// //                   </th>
// //                   <th scope="col" className="text-center">
// //                     DEBIT
// //                   </th>
// //                   <th scope="col" className="text-center">
// //                     CREDIT
// //                   </th>
// //                   <th scope="col" className="text-center">
// //                     BALANCE
// //                   </th>
                 
// //                 </tr>
// //               )}
// //             </thead>
// //             <tbody style={{height: "auto !important"}}>
// //               {tableData &&
// //                 tableData.map((item, key) => {
// //                   return (
// //                     <>
// //                       {seg === "dpc" && (
// //                         <tr key={key}>
// //                           <td>{item?.postingDate || "-"}</td>
// //                           <td>{item?.text || "-"}</td>
// //                           <td>{item?.debit || 0}</td>
// //                           <td>{item?.credit}</td>
// //                           <td>{item?.balance || 0}</td>
// //                         </tr>
// //                       )}
                   
// //                     </>
// //                   );
// //                 })}
// //             </tbody>
// //           </table>
// //         </div>
// //       )}
// //     </>
// //   );
// };
// export default ApLedgerReport;


// import React, { useState } from "react";

// const ApLedgerReport = ({ data, seg }) => {
//   const tableData =
//     seg === "dpc"
//       ? data?.apLadgerBalanceDetails
//       : seg === "prop"
//       ? data?.IntrestProp
//       : data?.IntrestMtf;

//   const tableDataFirst =
//     seg === "dpc"
//       ? data?.totalcount
//       : seg === "prop"
//       ? data?.IntrestProp
//       : data?.IntrestMtf;

//   // Pagination state for Table 3
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 5; // rows per page
//   const totalPages = Math.ceil((tableData?.length || 0) / rowsPerPage);

//   const currentRows = tableData?.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   return (
//     <>
//       {seg === "dpc" && tableDataFirst && (
//         <div className="ap-ledger-report-wrapper">
//           {/* Table 1 */}
//           <table className="ap-ledger-report table last-column">
//             <tbody>
//               <tr className="inner-row">
//                 {/* LEFT COLUMN */}
//                 <td className="left-column">
//                   <div className="cell-pair">
//                     <span className="title-cell">AP Name</span>
//                     <span className="value-cell">
//                       {tableDataFirst?.apCode || "-"}
//                     </span>
//                   </div>
//                   <div className="cell-pair">
//                     <span className="title-cell">AP Code</span>
//                     <span className="value-cell">
//                       {tableDataFirst?.apName || "-"}
//                     </span>
//                   </div>
//                 </td>

//                 {/* RIGHT COLUMN */}
//                 <td className="right-column">
//                   <div className="cell-pair">
//                     <span className="title-cell">Report Start Date</span>
//                     <span className="value-cell">
//                       {tableDataFirst?.startDate || "-"}
//                     </span>
//                   </div>
//                   <div className="cell-pair">
//                     <span className="title-cell">Report End Date</span>
//                     <span className="value-cell">
//                       {tableDataFirst?.endDate || "-"}
//                     </span>
//                   </div>
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           {/* Table 2 */}
//           <table className="ap-ledger-report table last-column">
//             <tbody>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From Brokerage</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeFromBrok || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From MTF</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeMtf || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From Mutual Funds</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeFromMutualFund || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Income From TPP</td>
//                 <td className="value-cell">{tableDataFirst?.totalIncomeFromTpp || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Amount Paid</td>
//                 <td className="value-cell">{tableDataFirst?.totalAmountPaid || "-"}</td>
//               </tr>
//               <tr className="inner-row">
//                 <td className="title-cell-income">Total Amount held so far for RMS Debit</td>
//                 <td className="value-cell">{tableDataFirst?.totalAmountRMSdbt || "-"}</td>
//               </tr>
//             </tbody>
//           </table>

//           {/* Table 3 with Pagination */}
//           <table className="ap-ledger-report table last-column">
//             <thead>
//               <tr>
//                 <th>AP NAME</th>
//                 <th>AP CODE</th>
//                 <th className="text-center">DEBIT</th>
//                 <th className="text-center">CREDIT</th>
//                 <th className="text-center">BALANCE</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentRows?.map((item, index) => (
//                 <tr key={index} className="inner-row">
//                   <td>{item?.postingDate || "-"}</td>
//                   <td>{item?.text || "-"}</td>
//                   <td>{item?.debit || 0}</td>
//                   <td>{item?.credit || 0}</td>
//                   <td>{item?.balance || 0}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination Controls */}
//           <div style={{ marginTop: "10px", textAlign: "center" }}>
//             <button
//               onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
//             <span style={{ margin: "0 10px" }}>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ApLedgerReport;



import React, { useState } from "react";

const ApLedgerReport = ({ data, seg }) => {
  const tableData =
    seg === "dpc"
      ? data?.apLadgerBalanceDetails
      : seg === "prop"
      ? data?.IntrestProp
      : data?.IntrestMtf;

  const tableDataFirst =
    seg === "dpc"
      ? data?.totalcount
      : seg === "prop"
      ? data?.IntrestProp
      : data?.IntrestMtf;

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const totalPages = Math.ceil((tableData?.length || 0) / rowsPerPage);
  const currentRows = tableData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Dynamic page range logic
  const pageNumbersToShow = 5;
  let startPage = Math.max(currentPage - Math.floor(pageNumbersToShow / 2), 1);
  let endPage = startPage + pageNumbersToShow - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - pageNumbersToShow + 1, 1);
  }

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };


 


  return (
    <>
      {seg === "dpc" && tableDataFirst && (
        <div className="ap-ledger-report-wrapper">
          {/* Table 1 */}
          <table className="ap-ledger-report table last-column">
            <tbody>
              <tr className="inner-row">
                <td className="left-column">
                  <div className="cell-pair">
                    <span className="title-cell">AP Name</span>
                    <span className="value-cell">{tableDataFirst?.apName || "-"}</span>
                  </div>
                  <div className="cell-pair">
                    <span className="title-cell">AP Code</span>
                    <span className="value-cell">{tableDataFirst?.apCode || "-"}</span>
                  </div>
                </td>
                <td className="right-column">
                  <div className="cell-pair">
                    <span className="title-cell">Report Start Date</span>
                    <span className="value-cell">{tableDataFirst?.startDate || "-"}</span>
                  </div>
                  <div className="cell-pair">
                    <span className="title-cell">Report End Date</span>
                    <span className="value-cell">{tableDataFirst?.endDate || "-"}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          {/* Table 2 */}
          <table className="ap-ledger-report table last-column">
            <tbody>
              <tr className="inner-row">
                <td className="title-cell-income">Opening Balance (A)</td>
                <td className="value-cell">{tableDataFirst?.openingBalance  || "-"}</td>
              </tr>
              <tr className="inner-row">
                <td className="title-cell-income">Deposit Balance (B)</td>
                <td className="value-cell">{tableDataFirst?.depositBalance || "-"}</td>
              </tr>
                    
              <tr className="inner-row">
                <td className="title-cell-income">Total Income From Brokerage (C)</td>
                <td className="value-cell">{tableDataFirst?.totalIncomeFromBrok || "-"}</td>
              </tr>
              <tr className="inner-row">
                <td className="title-cell-income">Total Income From MTF (D)</td>
                <td className="value-cell">{tableDataFirst?.totalIncomeMtf || "-"}</td>
              </tr>
              <tr className="inner-row">
                <td className="title-cell-income">Total Income From Mutual Funds (E)</td>
                <td className="value-cell">{tableDataFirst?.totalIncomeFromMutualFund || "-"}</td>
              </tr>
              <tr className="inner-row">
                <td className="title-cell-income">Total Income From TPP (F)</td>
                <td className="value-cell">{tableDataFirst?.totalIncomeFromTpp || "-"}</td>
              </tr>           
              <tr className="inner-row">
                <td className="title-cell-income">Total Amount Hold as AP Risk (G)</td>
                <td className="value-cell">{tableDataFirst?.totalAmountRMSdbt || "-"}</td>
              </tr>
              <tr className="inner-row">
                <td className="title-cell-income">Total Recovery from payout (H)</td>
                <td className="value-cell">{tableDataFirst?.totalRecoveryfrompayout || "-"}</td>
              </tr>
               <tr className="inner-row">
                <td className="title-cell-income">Total Amount Paid (I)</td>
                <td className="value-cell">{tableDataFirst?.totalAmountPaid || "-"}</td>
              </tr>
               <tr className="inner-row">
                <td className="title-cell-income">Other Debit/ Credit Adjustment (J)</td>
                <td className="value-cell">{tableDataFirst?.otherDebit || "-"}</td>
              </tr>
                <tr className="inner-row">
                <td className="title-cell-income">Ledger balance (A+B+C+D+E+F-G-H-I-J)</td>
                <td className="value-cell">{tableDataFirst?.ledgerbalance || "-"}</td>
              </tr>
            </tbody>
          </table>

          {/* Table 3 */}
          <table className="ap-ledger-report table last-column">
            <thead>
              <tr>
                <th>DATE</th>
                <th>PARTICULARS</th>
                <th>DEBIT</th>
                <th>CREDIT</th>
                <th>BALANCE</th>
              </tr>
            </thead>
            <tbody>
              {currentRows?.map((item, index) => (
                <tr key={index} className="inner-row">
                  <td>{item?.postingDate || "-"}</td>
                  <td>{item?.text || "-"}</td>
                  <td>{item?.debit || 0}</td>
                  <td>{item?.credit || 0}</td>
                  <td>{item?.balance || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
              padding: "10px 0",
            }}
          >
            {/* Left side - items per page */}
            <div>
              <label style={{ fontSize: "14px", fontWeight: 500 }}>
                Items per page:{" "}
                <select
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  style={{
                    padding: "3px 10px",
                    fontSize: "14px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    marginLeft: "5px",
                    width: "100px",
                    height: "22px",
                  }}
                >
                  {[5, 10, 15, 20, 50].map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            {/* Right side - pagination buttons */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                style={buttonStyle}
              >
                {"<<"}
              </button>

              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={buttonStyle}
              >
                {"<"}
              </button>

              {Array.from({ length: endPage - startPage + 1 }, (_, idx) => {
                const pageNum = startPage + idx;
                return (
                  <button
                    key={pageNum}
                    onClick={() => setCurrentPage(pageNum)}
                    style={{
                      ...pageNumberStyle,
                      backgroundColor:
                        currentPage === pageNum ? "#007bff" : "#fff",
                      color: currentPage === pageNum ? "#fff" : "#333",
                      border:
                        currentPage === pageNum
                          ? "2px solid #007bff"
                          : "1px solid #ccc",
                    }}
                  >
                    {pageNum}
                  </button>
                );
              })}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                style={buttonStyle}
              >
                {">"}
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                style={buttonStyle}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// ✅ Pagination button styles
// const buttonStyle = {
//   padding: "6px 10px",
//   fontSize: "16px",
//   cursor: "pointer",
//   border: "1px solid #ccc",
//   borderRadius: "4px",
//   backgroundColor: "#fff",
//   transition: "all 0.2s",
// };

// const pageNumberStyle = {
//   width: "38px",
//   height: "38px",
//   fontSize: "16px",
//   fontWeight: 600,
//   textAlign: "center",
//   lineHeight: "38px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   transition: "all 0.3s ease",
// };

// ✅ Updated Pagination button styles
const buttonStyle = {
  width: "22px",
  height: "22px",
  fontSize: "12px",
  cursor: "pointer",
  border: "1px solid #ccc",
  borderRadius: "4px",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0", // removed extra padding to fit 22px
  transition: "all 0.2s",
};

const pageNumberStyle = {
  width: "22px",
  height: "22px",
  fontSize: "12px",
  fontWeight: 600,
  textAlign: "center",
  lineHeight: "22px",
  borderRadius: "4px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};


export default ApLedgerReport;
